import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const railway = defineConnector({
  identifier: "railway",
  name: "Railway",
  tagLine: "App deployment platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://backboard\\.railway\\.app/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Railway](https://railway.app/) and navigate to **Account Settings** > **Tokens** to create a new API token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "Railway API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://backboard.railway.app/graphql/v2",
  },
});
